<script setup>
import { useUserStore } from "@/store/user-store";
import GoalDashboard from "@/tabs/my-goals/GoalDashboard.vue";
import SetGoals from "@/tabs/my-goals/SetGoals.vue";
import { ref } from "vue";

const store = useUserStore();

const sectionId = ref(1);

const setSection = (id) => {
  sectionId.value = id;
};
</script>

<template>
  <div>
    <section v-if="sectionId === 1">
      <GoalDashboard :setSection="setSection" />
    </section>
    <section v-else-if="sectionId === 2">
      <SetGoals :setSection="setSection" />
    </section>
  </div>
</template>

<style scoped></style>
